module.exports = __webpack_public_path__ + "static/media/06-thumbnail.20456fff.jpg";